import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import { SharedService } from "src/app/services/shared.service";
import * as $ from "jquery";

@Component({
  selector: "app-airportforgedresults",
  templateUrl: "./airportforgedresults.component.html",
  styleUrls: ["./airportforgedresults.component.scss"],
})
export class AirportforgedresultsComponent implements OnInit {
  apiUrl: string;
  uploadResultForm: FormGroup;
  searchForm: FormGroup;
  forgedresults: any = {};

  status: boolean = false;
  dtOptions: any = {};
  submitted = false;

  config: any;
  currentPageLength: any = 10;
  searchObject: any = {};

  sampleSingleResponse: any;
  fileUploaded: File;
  storedData: any;
  csvData: any;
  worksheet: any;

  daterange: any = {};

  options: any = {
    locale: { format: "YYYY-MM-DD" },
    alwaysShowCalendars: false,
  };

  uploadSampleFileTemplate: any;
  minDate: any = "";
  maxDate: any = "";

  applicationId: any;
  airportPersonel: any;
  resultForm: FormGroup;
  appointmentDetails: any;
  travelDetails: any;
  collectionCenters: any;
  lgas: any;
  airline: any;
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService,
    public shared: SharedService
  ) {}

  ngOnInit(searchObj = null) {
    this.sess.checkLogin();

    this.applicationId = localStorage.getItem("application_id");
    this.airportPersonel = environment.APP_ID_AIRPORT_PERSONAL;
    this.sess.confirmUser(
      this.applicationId,
      this.airportPersonel,
      "Airport Personel"
    ); 
      // this.getAirline()
    if (searchObj == null || searchObj == "") {
      this.forgedresults = "";
      this.initialiseForm();
      this.initTable();
      console.log("searchObj is null");
    } else {
      this.forgedresults = "";
      console.log("searchObj is not null");
    }

    /* Pagination Start */
    this.config = {
      currentPage: 1,
      itemsPerPage: 10,
    };
    this.initResultForm()
    this.getForgedresults(this.config.itemsPerPage, this.config.currentPage);

    this.route.queryParams.subscribe(
      (params) =>
        (this.config.currentPage = params["page"] ? params["page"] : 1)
    );
    this.shared.getTravelTypes();
  }

  initialiseForm() {
    this.searchForm = this.formBuilder.group({
      passportNumber: [""],
      passengerName: [""],
      phone: [""],
      // result_validity: [""],
      // daterangeInput: [""],
    });
  }
  initResultForm(){
    this.resultForm = this.formBuilder.group({
      fullname: [""],
      appointmentId: [""],
      phone: [""],
      occupation: [""],
      address: [""],
      email: [""],
      gender: [""],
      status: [""],
      dob: [""],
      nationality: [""], 
    });

  }

  updateResultForm(result){
    this.resultForm = this.formBuilder.group({
      fullname: [result.first_name + " " + result.last_name],
      appointmentId: [result.ctms_passenger_id],
      phone: [result.phone],
      occupation: [result.occupation],
      address: [result.address_residential],
      passportNumber: [result.passport_no],
      email: [result.email],
      gender: [result.gender],
      status: [result.status],
      dob: [result.dob],
      nationality: [result.nationality], 
    });
  }

  initTable() {
    this.dtOptions = {
      paging: false,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: false,
      processing: false,
      ordering: false,
      info: false,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }

  getCollectionCenters(id) {
    this.apiUrl = environment.AUTHAPIURL + "collection-center-list";

    const obj = {
       
    };
    this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
      console.log("collectionCenters: ", data);
      this.collectionCenters = data.response.data;
    });
    let center = this.collectionCenters.filter(x => x.id === id);
    return center.name;
  }

  getLgas(id) {
		this.apiUrl = environment.AUTHAPIURL + 'lga-list';
		const obj = {};
		this.http.post<any>(this.apiUrl, obj).subscribe((data) => {
			console.log('lga: ', data);
			this.lgas = data.response;
		});
    let lga =  this.lgas.filter(x => x.id === id);
    return lga.name;
	}
 
  getAirline(id) {
		this.apiUrl = environment.AUTHAPIURL + 'airlines';

		this.http.get<any>(this.apiUrl).subscribe((data) => {
			console.log('airline: ', data);
			this.airline = data.response;
		});
    let airline = this.airline.filter(x =>x.id === id);
    return airline.name;
	}

  getForgedresults(perpage, pageno) {
    this.spinnerService.show();

    this.apiUrl =
      `${environment.AUTHAPIURL}passengers/forged?page=` + pageno;

    this.searchObject["page_no"] = pageno;
    this.searchObject["per_page"] = perpage;
    this.searchObject["application_id"] =
      localStorage.getItem("application_id");
    this.searchObject["role_id"] = localStorage.getItem("role_id");

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    //temp - To be removed when API is implementated
    this.forgedresults = [];
    this.config.totalItems = 0;

    this.http
      .post<any>(this.apiUrl, this.searchObject, { headers: reqHeader })
      .subscribe((data) => {
        this.spinnerService.hide();
        if (data.status == true) {
          console.log(data);
          this.forgedresults = data.response.data;
          this.config.totalItems = data.response.total;
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  viewResult(modal, passenger){
    console.log(passenger);
    this.travelDetails = passenger.travel_details
    this.appointmentDetails = passenger.appointment_details
    this.updateResultForm(passenger)
    this.utility.showModal(modal)
  }

  pageChange(newPage: number) {
    this.forgedresults = "";
    this.router.navigate(["/airportforgedresults"], {
      queryParams: { page: newPage },
    });
    this.getForgedresults(this.config.itemsPerPage, newPage);
  }

  public setItemsPerPage(event) {
    this.config.itemsPerPage = event;
    this.currentPageLength = this.config.itemsPerPage;
    this.forgedresults = "";
    this.router.navigate(["/airportforgedresults"]);
    this.getForgedresults(this.config.itemsPerPage, 1);
  }

  onSubmitSearch(formAllData: any) {
    this.submitted = true;

    // stop the process here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.searchObject = {
      passport_no: formAllData.passportNumber, 
      name: formAllData.passengerName, 
      phone: formAllData.phone, 
    };

    console.log("searchFormData: ", this.searchObject);
    this.forgedresults = "";
    this.getForgedresults(this.config.itemsPerPage, this.config.currentPage);
  }

  clearSearch() {
    this.forgedresults = "";
    this.searchObject = {};
    this.initialiseForm();
    this.getForgedresults(this.config.itemsPerPage, this.config.currentPage);
  }

  selectedDate(value: any, datepicker?: any) {
    // this is the date  selected
    console.log("selectedDate: ", value);

    // any object can be passed to the selected event and it will be passed back here
    // datepicker.start = value.start;
    // datepicker.end = value.end;

    // use passed valuable to update state
    this.daterange.start = value.start.format("YYYY-MM-DD");
    this.daterange.end = value.end.format("YYYY-MM-DD");
    this.daterange.label = value.label;
  }
}
